import ProjectAnalysis from './pages/ProjectAnalysis';
import ChangePassword from './pages/ChangePassword';

import React, { useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import AppLogout from "./components/AppLogout";
import Layout from "./components/Layout/Layout";
import Home from "./pages/Home";
import Register from "./pages/Register";
import NotFound from "./pages/NotFound";
import Reporting from "./pages/Reporting";
import RiskManagement from "./pages/RiskManagement";
import DataCollection from "./pages/DataCollection";
import ProjectManagement from "./pages/ProjectManagement";
import ProjectList from "./pages/ProjectList";
import RiskDashboard from "./pages/RiskDashboard";
import AfricaMaps from "./pages/AfricaMaps";
import Login from "./pages/Login";
import SDataCollection from "./pages/SDataCollection";
import LandingPage from "./pages/landingpage";
import StakeholderManagement from "./pages/Stakeholder";
import UserManagement from "./pages/UserManagement";
import DataAnalysis from "./pages/DataAnalysis";
import StakeholderDashboard from "./pages/StakeholderDashboard";
import RiskAnalysis from "./pages/RiskAnalysis";
import AboutPage from "./pages/About";
import MEModule from "./pages/M&E";
import ICTNewsEvents from "./pages/ICTNewsEvents";
import Budget from "./pages/budget";
import BudgetDashboard from "./pages/budgetDashboard";
import BudgetAnalysis from "./pages/BudgetAnalysis";
import ClimateDashboard from "./pages/ClimateDashboard";
import Documentation from "./pages/Documentation";
import NotificationPopup from "./pages/NotificationPopup";
import ApiKeyGenerator from "./pages/apikey";
import VerifyCodePopup from "./pages/VerifyCodePopup";
import DataDraft from "./pages/dataDraft";
import ReminderPage from "./pages/reminder";
import NewsAndEventsPage from "./pages/NewsEventDeshboard";
import EditProject from "./pages/EditProject";
import IctStatDashboard from "./pages/IctStatDashboard";
import ForgotPassword from "./pages/forgotePassword";
import UpdatePassword from "./pages/updatePassword";
import ResetPassword from "./pages/ResetPassword";
import ICTStatistics from "./pages/ICTStatistics";

function App() {
  const [projects, setProjects] = useState([]);
  const [currentProject, setCurrentProject] = useState(null);
  const [popupOpen, setPopupOpen] = useState(false);

  const handleAddProject = (newProject) => {
    setProjects([
      ...projects,
      { id: Date.now(), ...newProject, status: "Active" },
    ]);
    setCurrentProject(null);
  };

  const handleEditProject = (id) => {
    const projectToEdit = projects.find((project) => project.id === id);
    setCurrentProject(projectToEdit);
  };

  const handleUpdateProject = (updatedProject) => {
    setProjects(
      projects.map((project) =>
        project.id === updatedProject.id ? updatedProject : project
      )
    );
    setCurrentProject(null);
  };

  const handleDeleteProject = (id) => {
    setProjects(projects.filter((project) => project.id !== id));
  };

  return (
    <Router>
      <AppLogout>
        <Routes>
          <Route path="/about" element={<AboutPage />} />
          <Route path="/verifycodepopup" element={<VerifyCodePopup />} />
          <Route path="/register" element={<Register />} />
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgotpassword" element={<ForgotPassword />} />
          <Route path="/updatepassword" element={<UpdatePassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/change-password" element={<ChangePassword />} />

          <Route element={<Layout />}>
            <Route path="/home" element={<Home />} />
            <Route
              path="/dashboard"
              element={
                <ProjectManagement
                  onSubmit={handleAddProject}
                  currentProject={currentProject}
                />
              }
            />
            <Route
              path="/project-list"
              element={
                <ProjectList
                  projects={projects}
                  onEdit={handleEditProject}
                  onDelete={handleDeleteProject}
                />
              }
            />
            <Route path="/reporting" element={<Reporting />} />
            <Route path="/data-collection" element={<DataCollection />} />
            <Route path="/risk-management" element={<RiskManagement />} />
            <Route path="/risk-dashboard" element={<RiskDashboard />} />
            <Route path="/africa-map" element={<AfricaMaps />} />
            <Route path="/sdata-collection" element={<SDataCollection />} />
            <Route
              path="/stakeholdermanagement"
              element={<StakeholderManagement />}
            />
            <Route path="/usermanagement" element={<UserManagement />} />
            <Route path="/dataanalysis" element={<DataAnalysis />} />
            <Route
              path="/stakeholder-dashboard"
              element={<StakeholderDashboard />}
            />
            <Route path="/risksnalysis" element={<RiskAnalysis />} />
            <Route path="/edit-project" element={<EditProject />} />
            <Route path="/m&e" element={<MEModule />} />
            <Route path="/ictn" element={<ICTNewsEvents />} />
            <Route path="/budget" element={<Budget />} />
            <Route path="/budget-dashboard" element={<BudgetDashboard />} />
            <Route path="/budget-analysis" element={<BudgetAnalysis />} />
            <Route path="/climate-dashboard" element={<ClimateDashboard />} />
            <Route path="/documentation" element={<Documentation />} />
            <Route path="/apikeygenerator" element={<ApiKeyGenerator />} />
            <Route path="/datadraft" element={<DataDraft />} />
            <Route path="/new-event" element={<NewsAndEventsPage />} />
            <Route path="/ict-statistics" element={<ICTStatistics />} />
            <Route
              path="/ict-statistics-dashboard"
              element={<IctStatDashboard />}
            />


            <Route path="/reminder" element={<ReminderPage />} />
 <Route path="/project-analysis" element={<ProjectAnalysis/>}/>
            <Route
              path="/notificationpopup"
              element={<NotificationPopup setPopupOpen={setPopupOpen} />}
            />
          </Route>

          <Route path="*" element={<NotFound />} />
        </Routes>
      </AppLogout>
    </Router>
  );
}

export default App;
